import { camelCase } from 'change-case';

const firstStickyItemName = 'list-item-sticky-first';
const firstStickyGroupName = 'list-group-sticky-first';
const lastStickyItemName = 'list-item-sticky-last';
const lastStickyGroupName = 'list-group-sticky-last';

export const firstStickyItemDataName = camelCase(firstStickyItemName);
export const firstStickyGroupDataName = camelCase(firstStickyGroupName);
export const lastStickyItemDataName = camelCase(lastStickyItemName);
export const lastStickyGroupDataName = camelCase(lastStickyGroupName);

export const getDataAttrSelector = (name: string): `[data-${string}="true"]` => `[data-${name}="true"]`;

/**
 * Helper function for ListNavigation

 * Takes an element in a SelectionList and finds out if it is being covered by
 * a sticky list element
 *
 */
export const obscuredByStickyElement = (el: Element, container: Element) => {
  const elBoundingClientRect = el.getBoundingClientRect();

  const firstStickyItem = container.querySelector(getDataAttrSelector(firstStickyItemName));

  if (el === firstStickyItem) {
    return { result: false, extent: null };
  }

  const firstStickyItemRectangle = firstStickyItem?.getBoundingClientRect();

  let firstYExtent = 0;

  if (firstStickyItemRectangle) {
    firstYExtent = firstStickyItemRectangle.y + firstStickyItemRectangle.height;
  }

  const lastStickyItem = container.querySelector(getDataAttrSelector(lastStickyItemName));

  if (el === lastStickyItem) {
    return { result: false, extent: null };
  }

  const lastStickyItemRectangle = lastStickyItem?.getBoundingClientRect();

  const lastStickyGroupRectangle = container
    .querySelector(getDataAttrSelector(lastStickyGroupName))
    ?.getBoundingClientRect();

  const elYExtent = elBoundingClientRect?.y + elBoundingClientRect?.height;

  if (elYExtent <= firstYExtent) {
    return { result: true, extent: elBoundingClientRect.height, elIsSticky: false };
  }

  if (elYExtent >= (lastStickyGroupRectangle?.y || lastStickyItemRectangle?.y)) {
    return { result: true, extent: elBoundingClientRect.height, elIsSticky: false };
  }

  return { result: false, extent: null };
};
